import { SearchUnitHistoryResponse, UnitOption } from '@mark43/cad-api';
import { useMemo, useState } from 'react';
import { useBroadcast } from '../../common/broadcast-channel/use-broadcast';
import { UnitHistoryContext } from './unit-history-context';

export function UnitHistoryProvider({
    children,
}: {
    children: React.ReactNode;
}): React.ReactElement {
    const [selectedUnitOption, setSelectedUnitOption] = useState<UnitOption | null>(null);
    const [searchUnitHistoryResponse, setSearchUnitHistoryResponse] = useState<
        SearchUnitHistoryResponse | undefined
    >(undefined);
    const { postMessage } = useBroadcast('set-unit-history-selected-unit-option', ({ payload }) => {
        setSelectedUnitOption(payload.unitOption);
    });
    const unitHistoryState = useMemo(
        () => ({
            selectedUnitOption,
            setSelectedUnitOption: (unitOption: UnitOption | null) => {
                setSelectedUnitOption(unitOption);
                postMessage({
                    type: 'SET_UNIT_HISTORY_SELECTED_UNIT_OPTION',
                    payload: { unitOption },
                });
            },
            searchUnitHistoryResponse,
            setSearchUnitHistoryResponse,
        }),
        [selectedUnitOption, searchUnitHistoryResponse, postMessage]
    );
    return (
        <UnitHistoryContext.Provider value={unitHistoryState}>
            {children}
        </UnitHistoryContext.Provider>
    );
}
